import _ from "lodash";
import { Navigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import '../assets/scss/style.scss';
import { adminRole, businessRole, distributorRole, employeeRole, masterDistributorRole, retailerRole, superDistributorRole } from "./common/constant";

function ProtectAdminRoute({Component}) {
  const { user: currentUser } = useSelector((state) => state.user);
  const { accessType } = useParams(); // "admin" or "employee"
  const roleMap = {
    admin: adminRole,      // or whatever your adminRole is
    employee: employeeRole,   // or whatever your employeeRole is
    business: businessRole,   // or whatever your employeeRole is
  };

  return !_.isEmpty(currentUser) && _.toNumber(currentUser.role) === roleMap[accessType] ? (
    <Component />
  ) : (
    <Navigate to="/Login" />
  );
}
export default ProtectAdminRoute;

export function ProtectEmployeeRoute({Component}) {
  const { user: currentUser } = useSelector((state) => state.user);

  return !_.isEmpty(currentUser) && _.includes([employeeRole], _.toNumber(currentUser.role)) ? (
    <Component />
  ) : (
    <Navigate to="/Login" />
  );
}

export function ProtectDistributorRoute({Component}) {
  const { user: currentUser } = useSelector((state) => state.user);

  return !_.isEmpty(currentUser) && _.includes([masterDistributorRole, superDistributorRole, distributorRole], _.toNumber(currentUser.role)) ? (
    <Component />
  ) : (
    <Navigate to="/Login" />
  );
}

export function ProtectRoute({Component}) {
  const { user: currentUser } = useSelector((state) => state.user);

  return !_.isEmpty(currentUser) && _.includes([retailerRole], _.toNumber(currentUser.role)) ? (
    <Component />
  ) : (
    <Navigate to="/Login" />
  );
}


//  return currentUser.role === "1" ? (
//     <AdminLayout />
//   ) : currentUser.role === "2" ? (
//     <BusinessLayout />
//   ) : currentUser.role === "3" ? (
//     <MasterLayout />
//   ) : currentUser.role === "4" ? (
//     <SuperLayout />
//   ) : currentUser.role === "5" ? (
//     <DistributorLayout />
//   ) : currentUser.role === "6" ? (
//     <FullLayout />
//   ) : currentUser.role === "7" ? (
//     <EmployeLayout />
//   ) : currentUser.role === "8" ? (
//     <SuperAdminLayout />
//   ) : (
//     <Navigate to="/Login" />
//   );